import script from "./UploadSummary.vue?vue&type=script&setup=true&lang=js"
export * from "./UploadSummary.vue?vue&type=script&setup=true&lang=js"

import "./UploadSummary.vue?vue&type=style&index=0&id=1969abc6&lang=scss"

const __exports__ = script;

export default __exports__